<template>
    <div style=""  v-if="open_request">
        <!-- <button type="button" class="btn" style="background:#ff0055; color:#ffffff; margin-bottom: 1em;" @click="close_request">Cancel</button> -->
        <div v-if="loading">
            <div v-if="loading" class="loading-md"></div>
            <p style="font-size:13px; color:#000000;">Preparing and Checking your Sellpoint for previously added products and services</p>
        </div>
        <form class="gw-form" v-else>
            <h6>Add a New Product Lookbook to your Gallery</h6>
            <p><span class="sp-form-descr">(your product lookbook is a collection or group of products you want to keep together as posts)</span></p>
            <div v-if="showGalleryForm">
                <div>
                 
                   <div class="form-group">
                        <label>Product lookbook Name <span class="sp-form-must">*</span></label>
                        <input type="text" v-model="gallery.gallery_name" value="" placeholder="What's the Name of your Lookbook">
                        
                    </div>
                    <div class="form-group">
                        <label>Description</label>
                        <textarea  v-model="gallery.gallery_description" placeholder="What's this Lookbook all about"></textarea>
                          
                    </div>
                   
                </div>
            </div>
                <!-- <h6 style="font-size:16px;">Add Products</h6> -->
                <div>
                    <div v-if="products.length > 0">
                        <h6 style="font-size:16px; margin-bottom:1em;">Do you want to add from your products?</h6>
                        <p><b><span class="sp-form-descr">Select from your Products/Services to add to Lookbook</span> (scroll to view all products)</b></p>
                        <div style="display:none"><!---a-hack-to-help-show-checked-when-product-image-is-clicked-instead-ofcheckbox-->
                            {{this.selected_produts}}
                        </div>
                        <div class="row sp-products-row">
                            <div class="col-xs-4" v-for="(p,pdex) in products" :key="pdex" style="padding:5px; margin:1em; width:10%; height:6em;">
                                <a :title="p.product_name" style="cursor:pointer;" @click="setComponent('add-to-gallery-product',p)">
                                    <div class="box-color-cube" v-if="p.product_images[0]">
                                        <sup><input type="checkbox" :id="p.product_id+'PRDC'" v-model="p.product_checked"></sup>
                                        <img :src="p.product_images[0].product_image" :id="p.product_id+'PRD'" class="product-select sp-prd-img" style="height:5em; width:95%;"/>
                                    </div>
                                    <br>
                                    <p style="font-size:9px; line-height:1.2"><b>{{p.product_name}}</b></p>
                                </a> 
                            </div>
                        </div>
                    </div>
                    
                    <div><hr/><button type="button" class="btn" style="background:#ffcc00;" @click="setComponent('show-add-product-form','')"><b><span v-if="products.length > 0"> Or </span> Add New Product / Service to this Lookbook</b></button></div>
                    
                    <!--product-form-->
                    <div v-if="showProductForm" style="margin-top:1em;">
                        <!-- <div class="col-sm-12" style="margin-top:1em;"> -->
                            <h6>Add Product / Service</h6>
                            <p><span class="sp-form-descr">(This would also be added to products in your sellpoint)</span></p>
                            <button type="button" class="pull-right btn" style="background:#cc6655; color:#ffffff;" @click="reset">Cancel</button>
                            <form class="gw-form" style="margin-top:1em;">
                                
                                   <div class="form-group">
                                        <label class="line-wrap">Product</label>
                                            <input class="sp-radio-btn" type="radio" v-model="is_product_service" value="product" style="height:20px;">
                                            &nbsp;&nbsp;&nbsp;
                                         <label> Service </label>
                                        <input class="sp-radio-btn" type="radio" v-model="is_product_service" value="service" style="height:20px;">
                                       <div class="sp-form-descr">is this a Product or Service?</div>
                                    </div>
                                 
                                   <div class="form-group">
                                        <label>Name<span class="sp-form-must">*</span> </label>
                                            <input type="text" v-model="product.product_name" value="" placeholder="Name of Product / Service">
                                       
                                    </div>
                                    
                                    <div class="form-group" v-if="sellpoint_categories.length > 0">
                                        <label> Select from My Shop Categories<span class="sp-form-must">*</span> </label>
                                        <select class="form-control" v-model="product.product_category" id="category-type-1" v-on:change="trackevent('category-type-1')">
                                            <option value="0" :disabled="category_type_1">Select</option>
                                            <option :disabled="category_type_1" v-for="category in sellpoint_categories" :key="category.business_category_id" :value="category.business_category_id">{{category.business_category}}</option>
                                        </select>
                                       
                                    </div>
                                    <!-- <li class="col-sm-1" v-if="sellpoint_categories.length != 0">
                                        <label><b> *Or </b></label>
                                    </div> -->
                                    <div class="form-group">
                                        <label><span v-if="sellpoint_categories.length > 0"><b>Or </b></span> Select from Related Categories </label>
                                        <select v-model="main_category" class="form-control" @change="getSubCategories(main_category)">
                                            <option value="0">Select</option>
                                            <option v-for="category in categories" :key="category.category_id" :value="category">{{category.category_name}}</option>
                                        </select>
                                       
                                        <br>
                                        <label v-if="sub_categories.length != 0"> Select a Category </label>
                                        <select v-model="product.product_sub_category" class="form-control category-type-2" v-on:change="trackevent('category-type-2')">
                                            <option value="0" :disabled="category_type_2">Select</option>
                                            <option :disabled="category_type_2" v-for="category in sub_categories" :key="category.sub_category_id" :value="category.sub_category_id">{{category.sub_category_name}}</option>
                                        </select>
                                       
                                        <!-- DEPRAC<label><span v-if="sellpoint_categories.length > 0"><b>Or </b></span> Select from Shop Categories
                                        <select v-model="product.product_sub_category" class="category-type-2" v-on:change="trackevent('category-type-2')">
                                            <option value="0" :disabled="category_type_2">Select</option>
                                            <option :disabled="category_type_2" v-for="category in sub_categories" :key="category.sub_category_id" :value="category.sub_category_id">{{category.sub_category_name}}</option>
                                        </select>
                                        </label>-->
                                    </div>
                                
                                    <div class="form-group">
                                        <label> <b>Or </b> Enter a specific Category</label>
                                            <input :disabled="category_type_3" type="text" v-model="product.product_listed_category" placeholder="" id="category-type-3" v-on:change="trackevent('category-type-3')">
                                    </div>
                                    <div class="form-group">
                                        <label> *Description</label>
                                            <textarea  v-model="product.product_description" placeholder="Provide details of your product/service"></textarea>
                                        
                                    </div>
                                    <!-- <h6>Add a product Item, you can add more items later</h6> -->
                                    
                                    <div class="form-group">
                                        <label>Price<span class="sp-form-must">*</span></label>
                                        <input type="number" v-model="product.product_item_price" placeholder="" required>
                                    </div>
                                    <!-- <div class="form-group">
                                        <label> More Information</label>
                                    </div> -->

                                    <div class="form-group" v-if="is_product_service == 'product'">
                                        <label>Weight(Kg)</label>
                                        <input type="number" v-model="product.product_item_weight"  step="any" placeholder="" required>
                                    </div>

                                    <div class="form-group">
                                        <label>Quantity </label>
                                        <input type="number" v-model="product.product_item_quantity"  placeholder="" required>
                                    </div>
                                    
                                    <div class="form-group">
                                        <span class="sp-form-descr">Maximum Upload Size {{max_upload}}</span>
                                        <div class="upload-btn-wrapper" style="cursor:pointer">
                                            <!-- <img class="img_responsive"/> -->
                                            <button type="button" class="upload-btn">Add <span style="text-transform: capitalize;">{{is_product_service}}</span> Image</button>
                                            <input type="file" id="input-file" @change="onFileChange($event)" accept="image/*"/>
                                            <span v-if="file_info[0]"><b>Added {{file_info[0].name}}</b></span>  
                                            <div v-if="action_loading" class="loading-sm"></div>                                                                                                                                                                                                                                                                                                                                      
                                        </div>
                                        <div><span class="sp-form-descr">(You can always add more images or video on this post)</span></div>
                                    </div>
                                    <div class="form-group">
                                        <p style="color:#ee87a6">{{data_success_message}}<br><br/>
                                        <span style="color:#ffcc00">{{data_error_message}}</span></p>
                                        <div v-if="action_loading" class="loading-sm"></div>
                                        <button :disabled="disable_btn" type="button" class="pull-left btn" style="background:#ff0055; color:#ffffff;" @click="addProduct">Add Product</button>
                                        <button type="button" class="pull-right btn" style=" color:#ffffff;" @click="reset">Cancel</button>
                                       
                                    </div>
                                
                            </form>
                        <!-- </div> -->
                    </div>
                    <div>
                        <div class="form-group" v-if="canAddGallery">
                            <p style="color:#ee87a6">{{data_success_message}}</p>
                            <button :disabled="disable_btn" v-if="addProductPost" type="button" class="btn" style="background:#ff0055; color:#ffffff;" @click="addProductPostGallery">Add Post to Lookbook</button>
                            <button :disabled="disable_btn" v-else  type="button" class="btn" style="background:#ff0055; color:#ffffff;" @click="addGallery">Add Lookbook</button>
                            <div v-if="action_loading" class="loading-sm"></div>
                        </div>
                    </div>
                    <!---./-product-form--->
                </div>   
              
        </form>
    </div>
</template>
<style>

</style>

<script>
import services from './../../services/service'; // Service Class
let service = new services();

export default {
    name: 'ProductForm',
    data () {
        return {
            open_request: true,
            user:{},
            sellpoint: {},
            sellpoint_categories: {},
            categories:{},
            main_category:{},
            sub_categories: [],
            products:{},
            product:{},
            post:{},
            gallery:{},
            selected_produts:[],
            product_item: {},
            disable_btn: false,
            imageForm: "",
            product_info: false,
            product_url: "",
            category_type_1: false,
            category_type_2: false,
            category_type_3: false,
            file_info: {},
            addProductPost:false,
            showGalleryForm: true,
            showProductForm:false,
            canAddGallery:false,
            is_product_service: "product",
            data_success_message: "",
            data_error_message:"",
            loading:true,
            action_loading:false,
            executed_kipper:false,
            pinched_products:[],
            max_upload: service.max_media_upload
        }
    },
    components: {
       
     },
    methods: {
        activate_processing(){
            this.disable_btn = true;
            this.action_loading = true;
        },

        deactivate_processing(){
            this.disable_btn = false;
            this.action_loading = false;
        },

        setComponent(attr1,attr2){
            if(attr1 == "add-to-gallery-product"){ 
                //check if previously added
                let if_index = this.selected_produts.indexOf(attr2.product_id);
                if(if_index != -1){ //added
                    //new for checkbox
                    attr2.product_checked = false;
                    //remove from array
                    // this.selected_produts.splice(if_index);
                    this.selected_produts.splice(if_index, 1); //works better
                    document.getElementById(attr2.product_id+"PRD").style.border = "none"; //unstyle
                   
                }else{
                    this.selected_produts.push(attr2.product_id);
                    attr2.product_checked = true;
                    document.getElementById(attr2.product_id+"PRD").style.border = "1px solid #0000CC";
                
                }
               
            }
            if(attr1 == "show-add-product-form"){
                this.showProductForm = true;
                this.canAddGallery = false;
            }
        },
        close_request(){
            this.open_request = false;
        },
        reset(){
            this.showProductForm = false;
            this.canAddGallery = true;
        },
        
        trackevent(e){
            // $('#category-type-3').disabled = true;
            if(e == "category-type-1" && this.product.product_category != 0 && this.product.product_category != undefined){
              this.category_type_2 = true;
              this.category_type_3 = true;
            }
            else if(e == "category-type-2" && this.product.product_sub_category != 0 && this.product.product_sub_category != undefined){
              this.category_type_1 = true;
              this.category_type_3 = true;
            }
            else if(e == "category-type-3" && this.product.product_listed_category != "" && this.product.product_listed_category != undefined){
              this.category_type_1 = true;
              this.category_type_2 = true; 
            }
            else{
            this.category_type_1 = false;
              this.category_type_2 = false;
              this.category_type_3 = false;
             }
        },
        preset() {
            this.loading = true;
            var credentials = {
                session_key: localStorage.getItem("sp_token")
            } 
            if(credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(response => {
                    if(response.body.status == 200) {
                        let data = response.body.data;
                        data.forEach(function(element) {
                            this.user.user_id = element.user_id;
                        }, this);
                        //get sellpoint categories
                        this.getSellpointCategories();
                        

                    }else {
                        this.$router.push('login');
                      }
                }).catch((err) => {
                    if(err) {
                        this.$router.push('login');
                    }
                })
            }else {
                this.$router.push('login');
            }
        },

        getSellpointCategories(){
            service.getBusinessByUserName(this, this.$route.params.id).then(response => {
                if(response.body.status == 200) {
                   this.sellpoint = response.body.data;
                   //let sellpoint_data = response.body.data;
                    service.getBusinessCategories(this, this.sellpoint.business_id).then(response => {
                        if(response.body.status == 200) {
                            this.sellpoint_categories = response.body.data;
                        }
                    }).catch((err) => {})
                    // this.getSubCategories(this.sellpoint.business_category_id);
                    this.getCategories(this.sellpoint.business_category_id);
                    this.getSellpointProducts();
                }
            }).catch((err) => {
                //log it
               // this.$router.push("/")
             //  console.log(err)
            })

        },

        //DEPRAC
        // getSubCategories(category){
        //     service.getBusinessSubCategories(this, category).then(response => {
        //         if(response.body.status == 200) {
        //             this.sub_categories = response.body.data;
        //         }
        //     }).catch((err) => {})
                
        // },

        getCategories(category){
            service.getMainCategories(this, category).then(response => {
               if(response.body.status == 200) {
                    this.categories = response.body.data;
                }
            }).catch((err) => {})
                
        },

        getSubCategories(category){
            if(category != undefined){
                this.sub_categories = category.sub_categories;
            }else{
                this.sub_categories = [];
            }
            
        },

        getSellpointProducts(){
            service.getBusinessProducts(this, this.sellpoint.business_id).then(response => {
                if(response.body.status == 200) {
                    this.products = response.body.data;
                    this.loading = false;
                    //check product length
                    if(this.products.length > 0){
                        this.canAddGallery = true;
                    }
                }else{
                    this.loading = false;
                }
            }).catch((err) => {this.loading = false;})
                
        },

        addGallery(){
            this.activate_processing();
            this.loading = true;
            //this.business.agree = true;
            var credentials = {
                gallery_new_group: true,
                gallery_group_type: 2, //product gallery
                gallery_group_point: this.sellpoint.business_id,
                gallery_group_name: this.gallery.gallery_name,
                gallery_group_description:this.gallery.gallery_description,
                gallery_post_group: 0, //no group as in new
                gallery_post_caption: this.post.post_caption || "nill",
                gallery_post_details: this.post.post_details || "nill",
                gallery_post_products: this.selected_produts || [], 
            }
          
            let navi = this.$router;
            if(credentials.gallery_post_details != undefined) {
                service.addGallery(this, credentials).then(function(data) {
                    if(data.body.status == 201) {
                        //toastr.success("Post Created", 'Success!');
                        this.data_success_message = "Processing, please wait ..."
                        //log user in
                        this.gallery = data.body.data;
                        // navi.push("/"+this.$route.params.id); //changed for now, info on banner
                        location.reload("/"+this.$route.params.id);

                         this.open_request = false;
                        // this.disable_btn = false;
                        // this.loading = false;
                        this.deactivate_processing();
                    }
                }).catch((err) => {
                    if(err) {
                        // toastr.warning("Something went wrong", 'Warning!'); 
                        this.data_error_message = "Something went wrong, preparing report ...";
                       // console.log(err)
                         this.deactivate_processing();
                    }
                })
            }else {
                // toastr.error('Kindly fill all fields', 'Warning!');
                this.data_error_message = "Kindly fill all fields ..";
                this.deactivate_processing();
            }
        },

        addProduct(){
            this.activate_processing();
            // this.loading = true;
            var credentials = {
                product_name: this.product.product_name,
                product_is_product_or_service: this.is_product_service,
                product_category: this.product.product_category || 0,
                product_sub_category: this.product.product_sub_category || 0,
                product_listed_category: this.product.product_listed_category || "nill",
                product_business: this.sellpoint.business_id,
                product_description: this.product.product_description || "nill",
                product_item_price: this.product.product_item_price,
                product_item_weight: this.product.product_item_weight || 1,
                product_item_quantity: this.product.product_item_quantity || 1
            }
            
            let navi = this.$router;
            if(credentials.product_name != undefined) {
                service.addProduct(this, credentials).then(function(data) {
                    if(data.body.status == 201) {
                        //toastr.success("Product Added Successfully", 'Success!');
                        this.data_success_message = "Processing, please wait ...";
                        //log user in
                        this.product = data.body.data;
                        
                        //add image
                        //let result = data.body.data;
                        // this.imageForm.append("data_id", this.product.product_item_id); //refac
                        this.imageForm.append("data_id", this.product.product_id);
                        // this.imageForm.append("data_type","product_items"); //refac
                        this.imageForm.append("data_type","products");
                        service.uploadDataPhoto(this, this.imageForm).then(data => {
                        if(data.body.status == 200){
                            
                            //1. add products,show products, add to selevted products array

                            //     //call get products to refresh list
                            //     this.getSellpointProducts();
                            //     //add this new product to selected_products array
                            //     this.selected_produts.push(this.product.product_id);
                            //    // this.setComponent("add-to-gallery-product",this.product);
                            //     //remove form
                            //     this.showProductForm = false;
                            //     //bring back add gallery button
                            //     this.canAddGallery = true;

                            //2. addproducts, add to selected products array and add gallery
                            /*
                            *this block was moved to a kipper functions
                            // this.selected_produts.push(this.product.product_id);

                            // //check if a ist gallery post or adding new post to gallery
                            // if(this.addProductPost){
                            //      this.addProductPostGallery();
                            // }else{
                            //    this.addGallery();
                            // }
                            */

                           //after processing check if kipper has been executed
                           if(!this.executed_kipper){
                               this.addProductKipper();
                           }
                           
                           

                        }
                        }).catch((err) => {
                                if(err) {
                                // log it
                               // console.log(err)
                                }
                            // toastr.warning("Something went wrong.", 'Warning!');
                            this.data_error_message = "Something went wrong, preparing report ...";
                            // this.disable_btn = false;
                            // this.loading = false;
                             this.deactivate_processing();
                        })

                        //if uploading takes time continue with calls in the kipper
                        let self = this;
                        setTimeout(function(){  self.addProductKipper(); }, service.upload_wait_period); //wait and call posts in gallery

                        //navi.push("/"+this.$route.params.id+"/"+this.product.product_url_name); //changed for now, info on banner

                        
                    }
                }).catch((err) => {
                    if(err) {
                        // toastr.warning("Something went wrong", 'Warning!'); 
                        this.data_error_message = "Something went wrong, preparing report ...";
                       // console.log(err)
                        // this.disable_btn = false;
                        // this.loading = false;
                         this.deactivate_processing();
                    }
                })
            }else {
                // toastr.error('Kindly fill all fields', 'Warning!');
                this.data_error_message = "Kindly fill all fields ...";
                // this.disable_btn = false;
                // this.loading = false;
                 this.deactivate_processing();
            }
        },

        addProductKipper(){
            this.executed_kipper = true;
             //a repeated set of calls in a function moved here to avoid verbosity
            this.selected_produts.push(this.product.product_id);
            //check if a ist gallery post or adding new post to gallery
            if(this.addProductPost){
                this.addProductPostGallery();
            }else{
                this.addGallery();
            }
        },

        addProductPostGallery(){
            this.disable_btn = true;
            this.loading = true;
            //set gallery for first or new post 
            let set_gallery = 0; //fallback incace of unexpected error
            if(this.$route.params.id1 != undefined){
                 set_gallery = this.gallery.gallery_posts_group_id;
            } 

            //this.business.agree = true;
            var credentials = {
                gallery_new_group: false,
                gallery_post_group: set_gallery, 
                gallery_post_caption: this.post.post_caption || "nill",
                gallery_post_details: this.post.post_details || "nill",
                gallery_post_products: this.selected_produts || [], 
            }
          
            let navi = this.$router;
            if(credentials.gallery_post_details != undefined) {
                service.addGallery(this, credentials).then(function(data) {
                    if(data.body.status == 201) {
                        //toastr.success("Post Created", 'Success!');
                        this.data_success_message = "Processing, please wait ..."
                        //log user in
                        this.gallery = data.body.data;
                        location.reload("/"+this.$route.params.id);
                        //navi.push("/"+this.$route.params.id); //changed for now, info on banner
                        
                        this.open_request = false;
                        // this.disable_btn = false;
                        // this.loading = false;
                    }
                }).catch((err) => {
                    if(err) {
                        // toastr.warning("Something went wrong", 'Warning!'); 
                        this.data_error_message = "Something went wrong, preparing report ...";
                       // console.log(err)
                        this.disable_btn = false;
                        this.loading = false;
                    }
                })
            }else {
                // toastr.error('Kindly fill all fields', 'Warning!');
                this.data_error_message = "Kindly fill all fields ..";
                this.disable_btn = false;
                this.loading = false;
            }
        },

        setGallery(){
            service.getGallerySearch(this, this.$route.params.id1).then(response => {
                if(response.body.status == 200) {
                    this.gallery = response.body.data;
                }
            }).catch((err) => {})
        },

     
        //uploads
        onFileChange(e) {
            let files = e.target.files || e.dataTransfer.files;
            if (files.length)
            {   
                this.file_info = files;
                let formData = new FormData();
                formData.append('photo', files[0]); 
                this.imageForm = formData;
            }   
        
        },

},
    created: function(){
        if(this.$route.params.id1 != undefined){
            this.setGallery();
            //adding product post to gallery
            this.showGalleryForm = false;
            this.addProductPost = true; //ctrl for adding posts to gallery
        }
        this.preset();
    }
}

</script>


// WEBPACK FOOTER //
// newproductgallery.vue?11b0da76